import React, { useEffect, useState, useRef } from "react";
import { IoIosStar, IoIosStarOutline } from "react-icons/io";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { LuMove } from "react-icons/lu";
import { GrNewWindow } from "react-icons/gr";
import {
  useFolderContentMutation,
  useEditFolderNameMutation,
  useCreateFolderMutation,
  useDeleteFolderMutation,
  useMoveFolderMutation,
  useDeleteWorkbookMutation,
  useRenameWorkbookMutation,
  useMoveWorkbookMutation,
  useToggleFavoriteMutation,
  useDuplicateWorkbookMutation,
} from "./libraryApiSlice";
import useTitle from "../hooks/useTitle";
import { IoArrowBackOutline } from "react-icons/io5";
import { Dropdown } from "flowbite-react";
import PublishWorkbook from "./reduxworkbook/components/WorkbookPopups/PublishWorkbook";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import LibraryFolderPaths from "./LibraryFolderPaths";
import LoadingIndicator from "../components/BasicComponents/LoadingIndicator";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import useAuth from "../hooks/useAuth";

export default function Library() {
  useTitle("Vizta Library");
  const [folderId, setFolderId] = useState("root");
  const [editingIndex, setEditingIndex] = useState(null);
  const [folderName, setFolderName] = useState("");
  const [dialogVisible, setDialogVisible] = useState(null);
  const [moveFolderModal, setMoveFolderModal] = useState(false);
  const [skipFolderContentQuery, setSkipFolderContentQuery] = useState(true);
  const [moveFolderId, setMoveFolderId] = useState(null);
  const [newParentFolderId, setNewParentFolderId] = useState(null);
  console.log(newParentFolderId);
  const [moveType, setMoveType] = useState("workbook");
  const dialogRef = useRef(null);
  const navigate = useNavigate();
  const { folderId: paramsFolderId } = useParams();
  console.log(paramsFolderId);
  const location = useLocation();
  const { username } = useAuth();

  const [
    editFolderName,
    {
      data: editFolderNameData,
      isLoading: isEditFolderNameLoading,
      isSuccess: isEditFolderNameSuccess,
      isError: isEditFolderNameError,
      error: editFolderNameError,
    },
  ] = useEditFolderNameMutation();
  const [
    createFolder,
    {
      data: createFolderData,
      isLoading: isCreateFolderLoading,
      isSuccess: isCreateFolderSuccess,
      isError: isCreateFolderError,
      error: createFolderError,
    },
  ] = useCreateFolderMutation();
  const [
    deleteFolder,
    {
      data: deleteFolderData,
      isLoading: isDeleteFolderLoading,
      isSuccess: isDeleteFolderSuccess,
      isError: isDeleteFolderError,
      error: deleteFolderError,
    },
  ] = useDeleteFolderMutation();
  const [
    moveFolder,
    {
      data: moveFolderData,
      isLoading: isMoveFolderLoading,
      isError: isMoveFolderError,
      isSuccess: isMoveFolderSuccess,
      error: moveFolderError,
    },
  ] = useMoveFolderMutation();
  const [
    getFolderContent,
    {
      data: folderContentData,
      isLoading: isFolderContentLoading,
      isSuccess: isFolderContentSuccess,
      isError: isFolderContentError,
      error: folderContentError,
    },
    refetch,
  ] = useFolderContentMutation({ skip: skipFolderContentQuery });
  const [
    toggleFavorite,
    {
      data: favoriteMessage,
      isError: isFavoriteError,
      isSuccess: isFavoriteSuccess,
      isLoading: isFavoriteLoading,
      error: favoriteError,
    },
  ] = useToggleFavoriteMutation();

  const [
    duplicateWorkbook,
    {
      data: duplicateData,
      isLoading: isDuplicateLoading,
      isError: isDuplicateError,
      error: duplicateError,
      isSuccess: isDuplicateSuccess,
    },
  ] = useDuplicateWorkbookMutation();

  if (isDuplicateSuccess) {
    console.log(duplicateData);
    if (duplicateData["newWorkbookId"]) {
      navigate(`/workbook?workbookid=${duplicateData["newWorkbookId"]}`);
    } else {
      console.error("newWorkbookId is undefined or null");
    }
  }

  const [deleteWorkbook] = useDeleteWorkbookMutation();
  const [renameWorkbook] = useRenameWorkbookMutation();
  const [moveWorkbook] = useMoveWorkbookMutation();

  console.log(paramsFolderId);
  useEffect(() => {
    if (paramsFolderId) {
      console.log(paramsFolderId);
      setSkipFolderContentQuery(false);
      getFolderContent({ folderId: paramsFolderId });
      setFolderId(paramsFolderId);
    }
  }, [paramsFolderId]);
  console.log(folderContentData);

  const handleOpenFolder = (id) => {
    console.log(id);
    setFolderId(id);
    const folderPath = id ? id : "root";
    navigate(`/home/dash/library/${folderPath}`);
    sessionStorage.setItem("folderId", id);
  };

  const handleFavoriteToggle = (id, type) => {
    const request = {
      workbookOrFolderId: id,
      type: type,
    };
    console.log(request);
    toggleFavorite(request);
  };

  useEffect(() => {
    if (!paramsFolderId) {
      setFolderId("root");
      setSkipFolderContentQuery(false);
      // getFolderContent({ folderId: "root" });
    }
  }, [location.pathname]);

  const handleNameChange = (e) => {
    setFolderName(e.target.value);
  };
  useEffect(() => {
    if (!isFavoriteLoading) {
      getFolderContent({ folderId: paramsFolderId });
    }
  }, [isFavoriteLoading, refetch]);

  const handleCreateFolder = async (isSubFolder = false) => {
    try {
      const response = await getFolderContent({ folderId });
      const existingFolders = response.data || [];

      const folderPrefix = `New folder`;
      const folderNumbers = existingFolders
        .filter((folder) => folder.name.startsWith(folderPrefix))
        .map((folder) => {
          const match = folder.name.match(/New folder(?: \((\d+)\))?$/);
          return match ? parseInt(match[1] || 0, 10) : null;
        })
        .filter((number) => number !== null)
        .sort((a, b) => a - b);

      let nextNumber = 0;
      for (const number of folderNumbers) {
        if (number === nextNumber) {
          nextNumber += 1;
        } else {
          break;
        }
      }

      const newFolderName =
        nextNumber === 0 ? folderPrefix : `${folderPrefix} (${nextNumber})`;

      // Create the new folder
      const createFolderBody = {
        folderName: newFolderName,
        parentFolderId: folderId,
      };
      await createFolder(createFolderBody);

      setSkipFolderContentQuery(true);
      await getFolderContent({ folderId });
    } catch (error) {
      console.error("Error creating folder:", error);
    }
  };

  const handleBlur = async () => {
    if (folderContentData[editingIndex].type === "folder") {
      // Existing logic for folders
      await editFolderName({
        folderId: folderContentData[editingIndex].id,
        name: folderName,
      }).finally(() => {
        setSkipFolderContentQuery(true);
        getFolderContent({ folderId });
      });
    } else {
      // Logic for renaming workbooks
      await renameWorkbook({
        workbookId: folderContentData[editingIndex].id,
        newWorkbookName: folderName,
      }).finally(() => {
        setSkipFolderContentQuery(true);
        getFolderContent({ folderId });
      });
    }
    setEditingIndex(null);
  };

  const handleFolderName = (index) => {
    setEditingIndex(index);
    setFolderName(folderContentData[index].name);
    setDialogVisible(null);
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter") {
      if (folderContentData[editingIndex].type === "folder") {
        await editFolderName({
          folderId: folderContentData[editingIndex].id,
          name: folderName,
        }).finally(() => {
          setSkipFolderContentQuery(true);
          getFolderContent({ folderId });
        });
      } else {
        await renameWorkbook({
          workbookId: folderContentData[editingIndex].id,
          newName: folderName,
        }).finally(() => {
          setSkipFolderContentQuery(true);
          getFolderContent({ folderId });
        });
      }
      setEditingIndex(null);
    }
  };

  const handleDeleteFolder = (id) => {
    console.log(id);
    deleteFolder({ folderId: id }).finally(() => {
      setSkipFolderContentQuery(true);
      getFolderContent({ folderId });
    });
  };

  const handleDeleteWorkbook = (id) => {
    console.log(id);
    deleteWorkbook({ workbookId: id }).finally(() => {
      setSkipFolderContentQuery(true);
      getFolderContent({ folderId });
    });
  };

  const handleMove = () => {
    if (moveFolderId && newParentFolderId) {
      const actionPayload = {
        workbookId: moveFolderId,
        newFolderId: newParentFolderId,
      };

      if (moveType === "workbook") {
        moveWorkbook(actionPayload)
          .unwrap()
          .then(() => {
            getFolderContent({ folderId }); // Refresh folder content
          })
          .catch((error) => {
            console.error("Error moving workbook:", error);
            // Handle error (e.g., show a notification)
          })
          .finally(() => {
            setMoveFolderModal(false); // Close the modal
          });
      } else {
        // Handle moving a folder
        moveFolder({
          folderId: moveFolderId,
          newParentFolderId: newParentFolderId,
        })
          .unwrap()
          .then(() => {
            getFolderContent({ folderId }); // Refresh folder content
          })
          .catch((error) => {
            console.error("Error moving folder:", error);
            // Handle error (e.g., show a notification)
          })
          .finally(() => {
            setMoveFolderModal(false); // Close the modal
          });
      }
    } else {
      console.warn("Missing moveFolderId or newParentFolderId");
    }
  };

  const handleOpenWorkbook = (workbookId, sheetId) => {
    if (workbookId && sheetId) {
      console.log("open workbook");
      navigate(`/dashboard?workbookid=${workbookId}&sheetid=${sheetId}`);
      // navigate(`/publicdashboard?workbookid=${workbookId}&sheetid=${sheetId}`);
    } else {
      console.log("selectedSheetId is null or undefined");
    }
  };

  const handleClickOutside = (event) => {
    if (dialogRef.current && !dialogRef.current.contains(event.target)) {
      setDialogVisible(false);
    }
  };

  useEffect(() => {
    if (dialogVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dialogVisible]);

  const handleDuplicateWorkbbok = (workbookId) => {
    console.log(workbookId);
    duplicateWorkbook(workbookId);
  };

  const items = folderContentData ?? [];
  console.log(items);

  const isLoading = [
    isFolderContentLoading,
    isEditFolderNameLoading,
    isCreateFolderLoading,
    isDeleteFolderLoading,
    isMoveFolderLoading,
    isFavoriteLoading,
  ].some(Boolean);

  const renderImage = (item) => {
    if (!item) return null;
    return item.type === "folder" ? (
      <img
        className="w-full h-full object-contain"
        src="/graph_img/file.png"
        alt="Folder"
        onClick={() => handleOpenFolder(item.id)}
      />
    ) : (
      <img
        className="w-full h-full object-contain"
        src={item.icon}
        alt="File"
        onClick={() => handleOpenWorkbook(item.id, item.selectedSheetId)}
      />
    );
  };
  console.log(items);
  console.log(items.filter((lItem) => lItem.id !== "66b4b31b5ae8edd2283da40a"));

  return (
    <main className="p-2 bg-[#EDEDED] flex flex-col items-center justify-center gap-2 h-[94vh] min-h-[94vh]">
      <section className="flex gap-2 items-center text-bold w-full justify-start p-1">
        <LibraryFolderPaths />
      </section>
      <section className="flex w-full gap-[7px] items-center justify-start p-1 rounded-sm">
        <button onClick={() => navigate(-1)} className="text-black">
          <IoArrowBackOutline />
        </button>
        <button
          className="w-16 h-6 border border-black text-black text-xs shadow rounded"
          onClick={handleCreateFolder}
        >
          New
        </button>
        {isFolderContentError &&
          folderContentError?.data?.message !== "Folder not found" && (
            <span className="text-red-800 shadow-2xl rounded-md px-1">
              {folderContentError?.data?.message}
            </span>
          )}
        {isEditFolderNameError && editFolderNameError ? (
          <span className="text-red-800 shadow-2xl rounded-md px-1">
            {editFolderNameError?.data?.message}
          </span>
        ) : null}
        {isCreateFolderError && createFolderError ? (
          <span className="text-red-800 shadow-2xl rounded-md px-1">
            {createFolderError?.data?.error}
          </span>
        ) : null}
        {isDeleteFolderError && deleteFolderError ? (
          <span className="text-red-800 shadow-2xl rounded-md px-1">
            {deleteFolderError?.data?.message}
          </span>
        ) : null}
        {isMoveFolderError && moveFolderError ? (
          <span className="text-red-800 shadow-2xl rounded-md px-1">
            {moveFolderError?.data?.message}
          </span>
        ) : null}
        {isFavoriteError && (
          <span className="text-red-800 shadow-2xl rounded-md px-1">
            Error : {favoriteError} , Please try again later!
          </span>
        )}
        {isFavoriteSuccess ? (
          <span className="text-green-800 shadow-2xl rounded-md px-1">
            {favoriteMessage["message"]}
          </span>
        ) : null}
        {isDuplicateError && duplicateError ? (
          <span className="text-red-800 shadow-2xl rounded-md px-1">
            {duplicateError?.data?.message}
          </span>
        ) : null}
      </section>
      <section className="flex gap-x-20 gap-y-16 flex-wrap h-[80vh] overflow-y-auto px-4 py-4 w-full">
        {items && items.length > 0 ? (
          items
            .filter((lItem) => lItem.id !== "66b4b31b5ae8edd2283da40a")
            .map((item, index) => (
              <section
                key={index}
                className="w-[228px] h-[150px] gap-3 bg-white rounded hover:shadow-xl cursor-pointer"
              >
                {item !== null && item.type === "folder" ? (
                  <img
                    className="w-full h-full object-contain"
                    src="/graph_img/file.png"
                    alt="Folder"
                    onClick={() => handleOpenFolder(item.id)}
                  />
                ) : (
                  <img
                    className="w-full h-full object-contain"
                    src={item !== null && item.icon}
                    alt="File"
                    onClick={() =>
                      handleOpenWorkbook(item.id, item.selectedSheetId)
                    }
                  />
                )}
                <div className="text-[14px] flex justify-between items-center pl-2">
                  {editingIndex === index ? (
                    <input
                      className="px-1 bg-white text-black min-w-32 w-32 text-center rounded h-9 border-gray-400 border truncate flex items-center"
                      value={folderName}
                      onChange={handleNameChange}
                      onKeyDown={handleKeyDown}
                      onBlur={handleBlur}
                      autoFocus
                    />
                  ) : (
                    <h2 className="w-[60%] truncate">
                      {item !== null && item.name}
                    </h2>
                  )}
                  <section className="flex gap-3 items-center justify-end pt-[4px] w-[40%]">
                    {/* Toggle favorite status using handleFavoriteToggle */}
                    {item !== null && item.favourite ? (
                      <IoIosStar
                        onClick={() =>
                          handleFavoriteToggle(
                            item !== null && item.id,
                            item !== null && item.type
                          )
                        }
                      />
                    ) : (
                      <IoIosStarOutline
                        onClick={() =>
                          handleFavoriteToggle(
                            item !== null && item.id,
                            item !== null && item.type
                          )
                        }
                      />
                    )}
                    <IoMdInformationCircleOutline />
                    <Dropdown
                      label={
                        <PiDotsThreeOutlineVerticalFill
                          className="text-black cursor-pointer"
                          onClick={() => setDialogVisible(index)}
                        />
                      }
                      placement="right-start"
                      arrowIcon={false}
                      className="flex flex-col items-center justify-left px-2 relative -top-[152%] left-[100%]"
                    >
                      <button
                        onClick={() => handleFolderName(index)}
                        className="w-full items-center justify-start flex gap-2 hover:text-teal-600"
                      >
                        <MdOutlineDriveFileRenameOutline /> Rename
                      </button>
                      {item !== null && (
                        <button
                          onClick={() => {
                            setMoveFolderModal(true); // Open the modal for moving a folder
                            setMoveFolderId(item.id); // Set the ID of the folder you want to move
                            setMoveType(
                              item.type === "folder" ? "folder" : "workbook"
                            ); // Set move type to workbook
                          }}
                          className="w-full items-center justify-start flex gap-2 hover:text-teal-600"
                        >
                          <LuMove /> Move
                        </button>
                      )}
                      <button
                        onClick={() => {
                          item !== null && item.type === "folder"
                            ? handleDeleteFolder(item.id)
                            : handleDeleteWorkbook(item.id);
                        }}
                        className="w-full items-center justify-start flex gap-2 hover:text-teal-600"
                      >
                        <RiDeleteBin6Line /> Delete
                      </button>
                      {item !== null && item.type === "workbook" ? (
                        <button
                          onClick={() => handleDuplicateWorkbbok(item.id)}
                          className="w-full items-center justify-start flex gap-2 hover:text-teal-600"
                        >
                          <GrNewWindow /> Edit As New
                        </button>
                      ) : null}
                    </Dropdown>
                  </section>
                </div>
              </section>
            ))
        ) : isFolderContentLoading ||
          isEditFolderNameLoading ||
          isCreateFolderLoading ||
          isDeleteFolderLoading ||
          isMoveFolderLoading ||
          isFavoriteLoading ? (
          <LoadingIndicator />
        ) : null}
      </section>

      {moveFolderModal ? (
        <PublishWorkbook
          closeModal={() => setMoveFolderModal(false)}
          moveFolderModal={moveFolderModal}
          setNewParentFolderId={setNewParentFolderId}
          handleMove={handleMove}
        />
      ) : null}
    </main>
  );
}
